"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _material = require("@mui/material");
var _Tabs = require("./Tabs.styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var createTabsRows = function createTabsRows(_ref) {
  var tabDefinitions = _ref.tabDefinitions,
    tabCreator = _ref.tabCreator,
    maxRowItemCount = _ref.maxRowItemCount;
  var rows = (0, _lodash.chunk)(tabDefinitions, maxRowItemCount);
  return rows.map(function (batch) {
    var children = batch.map(tabCreator);
    // Fill up the last row with the same number of invisible <Tab /> components
    // if necessary so that the last row's <Tabs /> component calculates the same
    // width for each <Tab /> if variant is set to "fullWidth" mode.
    var emptyTabs = rows.length > 1 && batch.length < maxRowItemCount ? Array(maxRowItemCount - batch.length).fill(undefined, undefined, undefined).map(function (val, index) {
      return /*#__PURE__*/_react["default"].createElement(_material.Tab, {
        key: "invisible-tab-".concat(index.toString()),
        disabled: true
      });
    }) : [];
    return [].concat(_toConsumableArray(children), _toConsumableArray(emptyTabs));
  });
};
var createTabs = function createTabs(_ref2) {
  var selected = _ref2.selected,
    onChange = _ref2.onChange,
    ariaLabel = _ref2.ariaLabel,
    children = _ref2.children,
    key = _ref2.key,
    variant = _ref2.variant,
    orientation = _ref2.orientation,
    widthLineTabEnd = _ref2.widthLineTabEnd,
    bottomLineTabEnd = _ref2.bottomLineTabEnd,
    leftLineTabEnd = _ref2.leftLineTabEnd;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Tabs, {
    orientation: orientation,
    value: selected,
    key: "tabs-".concat(key),
    indicatorColor: "primary",
    textColor: "primary",
    onChange: onChange,
    variant: variant,
    "aria-label": ariaLabel
  }, children), orientation === 'horizontal' && /*#__PURE__*/_react["default"].createElement(_Tabs.TabsLineEnd, {
    widthLineTabEnd: widthLineTabEnd,
    bottomLineTabEnd: bottomLineTabEnd,
    leftLineTabEnd: leftLineTabEnd
  }));
};
var DefaultTabs = function DefaultTabs(_ref3) {
  var children = _ref3.children,
    selected = _ref3.selected,
    onChange = _ref3.onChange,
    ariaLabel = _ref3.ariaLabel,
    variant = _ref3.variant,
    orientation = _ref3.orientation,
    widthLineTabEnd = _ref3.widthLineTabEnd,
    bottomLineTabEnd = _ref3.bottomLineTabEnd,
    leftLineTabEnd = _ref3.leftLineTabEnd;
  return /*#__PURE__*/_react["default"].createElement(_Tabs.TabsWrapper, null, createTabs({
    children: children,
    selected: selected,
    onChange: onChange,
    ariaLabel: ariaLabel,
    variant: variant,
    orientation: orientation,
    widthLineTabEnd: widthLineTabEnd,
    bottomLineTabEnd: bottomLineTabEnd,
    leftLineTabEnd: leftLineTabEnd
  }));
};
var MultiLineTabs = function MultiLineTabs(_ref4) {
  var tabDefinitions = _ref4.tabDefinitions,
    tabCreator = _ref4.tabCreator,
    maxRowItemCount = _ref4.maxRowItemCount,
    selected = _ref4.selected,
    onChange = _ref4.onChange,
    ariaLabel = _ref4.ariaLabel,
    variant = _ref4.variant,
    orientation = _ref4.orientation,
    widthLineTabEnd = _ref4.widthLineTabEnd,
    bottomLineTabEnd = _ref4.bottomLineTabEnd,
    leftLineTabEnd = _ref4.leftLineTabEnd;
  var tabs = createTabsRows({
    tabDefinitions: tabDefinitions,
    tabCreator: tabCreator,
    maxRowItemCount: maxRowItemCount
  }).map(function (children, key) {
    var keys = children.map(function (child) {
      return +child.key;
    });
    var selectedKey = keys.includes(selected) ? selected : false;
    return createTabs({
      selected: selectedKey,
      onChange: onChange,
      variant: variant,
      ariaLabel: ariaLabel,
      key: key,
      children: children,
      orientation: orientation,
      widthLineTabEnd: widthLineTabEnd,
      bottomLineTabEnd: bottomLineTabEnd,
      leftLineTabEnd: leftLineTabEnd
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_Tabs.TabsWrapper, {
    orientation: orientation
  }, tabs);
};
var NotifyTabs = function NotifyTabs(_ref5) {
  var children = _ref5.children,
    tabDefinitions = _ref5.tabDefinitions,
    tabCreator = _ref5.tabCreator,
    selected = _ref5.selected,
    ariaLabel = _ref5.ariaLabel,
    onChange = _ref5.onChange,
    variant = _ref5.variant,
    maxRowItemCount = _ref5.maxRowItemCount,
    orientation = _ref5.orientation,
    widthLineTabEnd = _ref5.widthLineTabEnd,
    bottomLineTabEnd = _ref5.bottomLineTabEnd,
    leftLineTabEnd = _ref5.leftLineTabEnd;
  var handleChange = function handleChange(e, value) {
    return onChange(value);
  };
  return tabDefinitions.length ? /*#__PURE__*/_react["default"].createElement(MultiLineTabs, {
    orientation: orientation,
    tabDefinitions: tabDefinitions,
    tabCreator: tabCreator,
    selected: selected,
    ariaLabel: ariaLabel,
    onChange: handleChange,
    maxRowItemCount: maxRowItemCount,
    variant: variant,
    widthLineTabEnd: widthLineTabEnd,
    bottomLineTabEnd: bottomLineTabEnd,
    leftLineTabEnd: leftLineTabEnd
  }) : /*#__PURE__*/_react["default"].createElement(DefaultTabs, {
    selected: selected,
    onChange: handleChange,
    ariaLabel: ariaLabel,
    variant: variant,
    orientation: orientation,
    widthLineTabEnd: widthLineTabEnd,
    bottomLineTabEnd: bottomLineTabEnd,
    leftLineTabEnd: leftLineTabEnd
  }, children);
};
DefaultTabs.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  selected: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  ariaLabel: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].string,
  orientation: _propTypes["default"].string,
  widthLineTabEnd: _propTypes["default"].string,
  bottomLineTabEnd: _propTypes["default"].string,
  leftLineTabEnd: _propTypes["default"].string
};
DefaultTabs.defaultProps = {
  children: [],
  variant: 'fullWidth',
  orientation: 'horizontal',
  widthLineTabEnd: '100%',
  bottomLineTabEnd: '0',
  leftLineTabEnd: '0'
};
MultiLineTabs.propTypes = {
  tabDefinitions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  tabCreator: _propTypes["default"].func,
  selected: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  ariaLabel: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].string,
  maxRowItemCount: _propTypes["default"].number,
  orientation: _propTypes["default"].string,
  widthLineTabEnd: _propTypes["default"].string,
  bottomLineTabEnd: _propTypes["default"].string,
  leftLineTabEnd: _propTypes["default"].string
};
MultiLineTabs.defaultProps = {
  tabDefinitions: [],
  tabCreator: function tabCreator() {},
  variant: 'fullWidth',
  maxRowItemCount: 5,
  orientation: 'horizontal',
  widthLineTabEnd: '100%',
  bottomLineTabEnd: '0',
  leftLineTabEnd: '0'
};
NotifyTabs.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  tabDefinitions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  tabCreator: _propTypes["default"].func,
  selected: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  ariaLabel: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].string,
  maxRowItemCount: _propTypes["default"].number,
  orientation: _propTypes["default"].string,
  widthLineTabEnd: _propTypes["default"].string,
  bottomLineTabEnd: _propTypes["default"].string,
  leftLineTabEnd: _propTypes["default"].string
};
NotifyTabs.defaultProps = {
  children: [],
  tabDefinitions: [],
  tabCreator: function tabCreator() {},
  variant: 'fullWidth',
  maxRowItemCount: 5,
  orientation: 'horizontal',
  widthLineTabEnd: '100%',
  bottomLineTabEnd: '0',
  leftLineTabEnd: '0'
};
var _default = exports["default"] = NotifyTabs;